import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SControlsList = styled.div`
  margin: 0 16px;
  gap: 2px;

  ${setFlexDF};
`;
